module.exports = __webpack_public_path__ + "cloud-security.1B4yLHWh.svg";